import React from 'react'
import PropTypes from 'prop-types'
import {addDays, areIntervalsOverlapping, parseISO, differenceInDays} from 'ag-common/facades'
import _ from 'lodash'
import Department from './Department'
import Termin from './Termin'
import {CalendarConfig} from '#tools/calendarConfig'
import UserCell from '#components/m/Versetzungsplan/UserCell'
import {connect} from 'react-redux'

const getVisibleItems = (items, startOfCalendar, endOfCalendar) => {
  const calendarRange = {
    start: startOfCalendar,
    end: endOfCalendar,
  }

  return items.filter(item => {
    const itemRange = {start: parseISO(item.from), end: parseISO(item.to)}
    return areIntervalsOverlapping(calendarRange, itemRange, {inclusive: true})
  })
}

function AppointmentsCell({
  azubi,
  abteilungen,
  termine,
  startOfCalendar,
  endOfCalendar,
  calendarType,
  abteilungsZeiten,
  isDashboardView = false,
  setSelectedAbteilungsEinsatz,
  editAbteilungseinsaetze,
}) {
  const vd = abteilungen ? getVisibleItems(abteilungen, startOfCalendar, endOfCalendar) : []
  const vt = termine ? getVisibleItems(termine, startOfCalendar, endOfCalendar) : []

  const calendarProps = {
    startOfCalendar,
    endOfCalendar,
    calendarType,
    userId: azubi.id,
    isDashboardView,
  }

  const userInfo = {
    firstname: azubi.firstname,
    lastname: azubi.lastname,
    name: `${azubi.firstname} ${azubi.lastname}`,
    id: azubi.id,
  }

  const hasDrafts = abteilungen?.filter(a => a.isDraft).length > 0

  const numberOfDays = differenceInDays(endOfCalendar, startOfCalendar) + 1
  const {getBorderColor} = CalendarConfig[calendarType]

  const gridColumnOffset = isDashboardView ? 0 : 1
  const gridTemplateColumns = isDashboardView
    ? `repeat(${numberOfDays}, 1fr)`
    : `284px repeat(${numberOfDays}, 1fr) 40px`

  return (
    <div className="cell" style={{gridTemplateColumns}}>
      <div className="background" style={{gridColumn: `1 / ${-1 - gridColumnOffset}`}} />
      {!isDashboardView && (
        <UserCell
          userToDisplayInfo={userInfo}
          editAbteilungseinsaetze={editAbteilungseinsaetze}
          hasDrafts={hasDrafts}
        />
      )}
      {_.times(numberOfDays, n => (
        <div
          key={`${calendarType}-${addDays(startOfCalendar, n)}`}
          data-date={addDays(startOfCalendar, n)}
          className="calendar__placeholder"
          style={{
            gridColumn: n + 1 + gridColumnOffset,
            borderColor: getBorderColor(addDays(startOfCalendar, n)),
          }}
        />
      ))}
      {vd.map(item => (
        <Department
          key={`abt-${item.id}`}
          {...item}
          {...abteilungsZeiten.find(z => z.abteilungId === item.abteilung.id)}
          {...calendarProps}
          from={parseISO(item.from)}
          to={parseISO(item.to)}
          setSelectedAbteilungsEinsatz={setSelectedAbteilungsEinsatz}
          userId={azubi.id}
          isDashboardView={isDashboardView}
        />
      ))}
      {vt.map(item => (
        <Termin
          key={`ter-${item.id}`}
          {...item}
          {...calendarProps}
          from={parseISO(item.from)}
          to={parseISO(item.to)}
          termine={termine}
          isDashboardView={isDashboardView}
        />
      ))}
    </div>
  )
}

AppointmentsCell.propTypes = {
  azubi: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    id: PropTypes.number,
  }).isRequired,
  abteilungen: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      abteilung: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        textColor: PropTypes.string,
        backgroundColor: PropTypes.string,
      }),
      from: PropTypes.string.isRequired,
      to: PropTypes.string.isRequired,
    }),
  ),
  abteilungsZeiten: PropTypes.arrayOf(
    PropTypes.shape({
      abteilungId: PropTypes.number,
      sollZeit: PropTypes.number,
      istZeit: PropTypes.number,
    }),
  ),
  termine: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      from: PropTypes.string.isRequired,
      to: PropTypes.string.isRequired,
      subject: PropTypes.string,
      gruppenId: PropTypes.string,
    }),
  ),
  startOfCalendar: PropTypes.instanceOf(Date).isRequired,
  endOfCalendar: PropTypes.instanceOf(Date).isRequired,
  calendarType: PropTypes.string.isRequired,
  isDashboardView: PropTypes.bool,
  numberOfWeeks: PropTypes.number,
  setSelectedAbteilungsEinsatz: PropTypes.func,
  editAbteilungseinsaetze: PropTypes.bool,
}

function mapStateToProps(state, props) {
  const versetzungsplan = state.versetzungsplan.versetzungsplaene
    ? state.versetzungsplan.versetzungsplaene.find(vp => vp.userId === props.azubi.id)
    : {}
  return {...versetzungsplan}
}

export {AppointmentsCell, getVisibleItems}
export default connect(mapStateToProps)(AppointmentsCell)
